import { Bnazanin } from "assets/fonts/pdfFont/PdfFont";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getCurrentTime, getToday } from "./portal/helper";
import { getDay } from "tools/functions/Methods";
// اطمینان حاصل کنید که فونت و لوگو به درستی ایمپورت شده‌اند
// import Bnazanin from path/to/font;
// import imageLogo from path/to/logo;

function MultiConsignments({ item }) {
  const formatNumber = (value) => {
    if (!value && value !== 0) return "0";
    const number = Number(value);
    return isNaN(number) ? "0" : number.toLocaleString();
  };

  // تابع کمکی برای نمایش اعداد منفی در پرانتز یا با رنگ (در html)
  const formatCurrency = (val) => formatNumber(val);

  return (
    <>
      {/* 
        تغییرات:
        1. ستون‌ها دقیقاً طبق عکس مرتب شدند (از راست به چپ در PDF، اینجا در HTML به ترتیب رندر می‌شوند).
        2. بخش‌های جمع کل (Footer) از داخل tbody حذف شدند تا جداگانه در PDF رسم شوند.
      */}
      <table hidden id="my-table-multi" className="border w-full">
        <thead>
          <tr>
            {/* ترتیب ستون‌ها برای jspdf-autotable (چپ به راست در کد، اما در PDF راست چین می‌شود) */}
            {/* ستون 1: ردیف */}
            <th>ردیف</th>
            {/* ستون 2: شماره مرسوله */}
            <th>شماره مرسوله</th>
            {/* ستون 3: نام گیرنده */}
            <th>نام گیرنده</th>
            {/* ستون 4: شهر مقصد */}
            <th>شهر مقصد</th>
            {/* ستون 5: وزن */}
            <th>وزن(کیلوگرم)</th>
            {/* ستون 6: نحوه پرداخت */}
            <th>نحوه پرداخت</th>
            {/* ستون 7: سرویس ارسال (در عکس "ترب" یا سرویس) */}
            <th>سرویس ارسال</th>
            {/* ستون 8: ارزش (ریال) */}
            <th>ارزش(ریال)</th>
            {/* ستون 9: وجه امانی COD */}
            <th>وجه امانی(ریال) COD</th>
            {/* ستون 10: هزینه سرویس ارسال */}
            <th>هزینه سرویس ارسال</th>
            {/* ستون 11: تخفیف سرویس ارسال */}
            <th>تخفیف سرویس ارسال</th>
            {/* ستون 12: خدمات جانبی */}
            <th>خدمات جانبی</th>
            {/* ستون 13: سایر خدمات */}
            <th>سایر خدمات</th>
             {/* ستون 14: خالص هزینه */}
             <th>خالص هزینه با اعمال تخفیف</th>
          </tr>
        </thead>
        <tbody>
          {item?.receiverAndConsignmentInfo?.map((row, index) => {
            const consInfo = row.consignmentInfo;
            const recInfo = row.receiverInfo;

            // محاسبه خالص هزینه برای هر سطر (فرضی، بر اساس دیتای موجود)
            const serviceCost = Number(consInfo?.servicesCost || 0);
            const discount = Number(row?.discount || 0); // فرض بر این است که تخفیف در سطح سطر هم دارید یا باید محاسبه شود
            const netCost = serviceCost - discount;

            return (
              <tr key={index}>
                {/* 1. ردیف */}
                <td>{index + 1}</td>
                {/* 2. شماره مرسوله */}
                <td>{consInfo?.consignmentNumber}</td>
                {/* 3. گیرنده */}
                <td>{recInfo?.name}</td>
                {/* 4. مقصد */}
                <td>{recInfo?.destinationCity}</td>
                {/* 5. وزن */}
                <td>{consInfo?.weight}</td>
                {/* 6. نحوه پرداخت (پیش کرایه/پس کرایه) */}
                <td>{consInfo?.wayOfPayment || "پیش کرایه"}</td>
                 {/* 7. سرویس ارسال */}
                 <td>{consInfo?.serviceType || "---"}</td>
                {/* 8. ارزش اظهار شده */}
                <td>{formatNumber(consInfo?.declaredValue)}</td>
                {/* 9. وجه امانی */}
                <td>{formatNumber(consInfo?.custodialAmount)}</td>
                {/* 10. هزینه سرویس */}
                <td>{formatNumber(consInfo?.servicesCost)}</td>
                {/* 11. تخفیف (معمولا منفی نمایش داده می‌شود) */}
                <td style={{ color: "red" }}>{formatNumber(discount)}</td>
                {/* 12. خدمات جانبی */}
                <td>{formatNumber(item?.sideServicesAmount || 0)}</td> 
                 {/* 13. سایر خدمات */}
                 <td>0</td>
                {/* 14. خالص هزینه */}
                <td>{formatNumber(netCost)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

export default MultiConsignments;
